{
  "dss": {
    "button": {
      "back": "Назад",
      "cancel": "Отмена",
      "close": "Закрыть",
      "confirmDelete": "Да, удалить",
      "continue": "Продолжить",
      "logout": "Выйти",
      "passwordReset": "Сброс пароля",
      "save": "Сохранить",
      "verify": "Подтвердить"
    },
    "error": {
      "403": "У вас нет доступа к этой странице.",
      "404": "Эта страница не существует.",
      "generic": "Произошла ошибка. Пожалуйста, попробуйте позже.",
      "throttling": "Слишком много попыток. Эта операция временно заблокирована.",
      "title": "Ошибка",
      "title403": "Доступ запрещен",
      "title404": "Не найдено"
    },
    "footer": {
      "imprint": "Imprint",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Политика конфиденциальности",
      "terms": "Условия и положения"
    },
    "label": {
      "CRMAccountNumber": "Номер учетной записи CRM",
      "contact": "Контакт",
      "email": "Эл. почта",
      "faq": "FAQ",
      "female": "Г-жа",
      "firstname": "Имя",
      "help": "Помощь",
      "language": "Язык",
      "lastname": "Фамилия",
      "male": "Г-н",
      "needHelp": "Нужна помощь?",
      "newPassword": "Новый пароль",
      "newPassword2": "Подтвердите новый пароль",
      "oldPassword": "Текущий пароль",
      "organization": "Организация",
      "password": "Пароль",
      "required": "обязательно",
      "salutation": "Обращение",
      "select": "Пожалуйста, выберите"
    },
    "lang": {
      "de": "Немецкий"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Подтвердите регистрацию",
        "wait": "Пожалуйста, подождите завершения подтверждения учетной записи."
      },
      "otp": {
        "btnResend": "Отправить код подтверждения еще раз",
        "msg": {
          "invalidOTP": "Введенный одноразовый пароль недействителен.",
          "resendFail": "Не удалось отправить код повторно. Пожалуйста, попробуйте позже."
        },
        "spamDetail": "Проверьте входящие и папку спам на наличие письма от STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Не получили письмо?",
        "subtitle": "Чтобы продолжить, необходимо подтвердить адрес электронной почты.",
        "title": "Подтвердите свою учетную запись",
        "txtVerifyMail": "Пожалуйста, введите новый код подтверждения, отправленный на адрес {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Нет данных для обновления.",
          "updateError": "Не удалось обновить персональные данные.",
          "updated": "Персональные данные обновлены.",
          "userLoadErr": "Ошибка при загрузке данных пользователя. Пожалуйста, попробуйте позже."
        },
        "secOrganization": "Организация",
        "secPersonal": "Личные",
        "secSettings": "Предпочитаемые настройки",
        "title": "Личная информация"
      },
      "postPwSet": {
        "info": "Теперь вы можете использовать новый пароль.",
        "link_name": "Перейти в Self-Service",
        "link_url": "/user/ui/",
        "title": "Ваш пароль был изменен"
      },
      "resetPW": {
        "title": "Сбросьте пароль"
      },
      "security": {
        "2fa": {
          "availableMethods": "Доступные методы 2FA:",
          "info": "Двухфакторная аутентификация (2FA) — это функция безопасности, которая добавляет дополнительный уровень защиты вашей учетной записи. Для входа требуется использовать два метода вместо одного логина и пароля.",
          "method": {
            "email": "Эл. почта",
            "emailDesc": "Получайте одноразовые коды по электронной почте для завершения запросов аутентификации.",
            "oath": {
              "add": {
                "button": "Зарегистрировать приложение Authenticator"
              }
            }
          }
        },
        "authenticator": "Приложение-аутентификатор",
        "infoFederatedAccount": "Эта учётная запись управляется поставщиком удостоверений вашей организации, поэтому пароль нельзя изменить здесь. Чтобы изменить пароль, войдите через страницу входа вашей организации или обратитесь к ИТ-администратору.",
        "lastUse": "Последнее использование: {0}.",
        "msg": {
          "invalidPassword": "Введен недействительный текущий пароль.",
          "passwordAlreadyUsed": "Нельзя повторно использовать последние 5 паролей.",
          "pwUpdateError": "Произошла ошибка при смене пароля.",
          "pwUpdated": "Пароль изменен."
        },
        "noDevice": "Не настроено",
        "oathAdd": {
          "appInfo": "Чтобы упростить вход в STIHL, вы можете использовать приложения-аутентификаторы, такие как {0}, {1}, {2} и т. д., для генерации одноразовых паролей, используемых как второй фактор при входе.<br/>Если вы потеряли или забыли мобильное устройство, вы всегда можете использовать 2FA-код, отправленный по электронной почте.<br/><br/>Пожалуйста, следуйте инструкциям ниже, чтобы настроить устройство аутентификации.",
          "badCode": "Недействительный код, пожалуйста, попробуйте снова.",
          "error": "Произошла ошибка при регистрации устройства аутентификации.",
          "headScan": "1. Отсканируйте QR-код в приложении-аутентификаторе",
          "headVerify": "2. Подтвердите код",
          "infoKey": "ключ настройки",
          "infoKeyTitle": "Ваш секрет двухфакторной аутентификации",
          "infoScanBottom": "Не получается сканировать? Вы можете использовать {0}, чтобы вручную настроить приложение-аутентификатор.",
          "infoVerify": "Введите код, сгенерированный вашим приложением-аутентификатором.",
          "success": "Ваше устройство аутентификации зарегистрировано. Теперь вы можете использовать его для входа.",
          "title": "Зарегистрируйте устройство двухфакторной аутентификации"
        },
        "oathDelete": {
          "error": "Произошла ошибка при удалении устройства аутентификации.",
          "success": "Устройство аутентификации удалено."
        },
        "passkeys": {
          "about": {
            "info1": "Passkey — это пары криптографических ключей (публичный и приватный), которые хранятся на контролируемом вами аутентификаторе. Аутентификатор может подтвердить присутствие пользователя и его право использовать passkey. Авторизация подтверждается PIN-кодом, кодом, биометрией или паролем устройства — в зависимости от возможностей и настроек аутентификатора. Аутентификаторы бывают разными: iPhone или Android-устройство, Windows Hello, аппаратный ключ безопасности FIDO2 или менеджер паролей.",
            "info2": "Когда вы входите в STIHL с использованием passkey, ваш аутентификатор применяет криптографию с открытым ключом, чтобы подтвердить вашу личность перед STIHL, не передавая сам passkey. Passkey привязаны к домену веб-сайта, например stihl-sso.com, и требуют защищенного соединения, поэтому браузер откажется аутентифицироваться на похожем фишинговом сайте. Эти свойства делают passkey высоко устойчивыми к фишингу и гораздо более трудными для атак, чем SMS или TOTP 2FA.",
            "info3": "Облачные сервисы passkey позволяют синхронизировать ключи между устройствами (например, устройствами Apple, Android или менеджерами паролей), чтобы их можно было использовать в большем количестве мест и меньше терять. Настроив синхронизируемый passkey на одном устройстве, вы сможете использовать его на нескольких устройствах, использующих тот же сервис. Например, если вы регистрируете passkey в своей учетной записи iCloud с помощью Touch ID на MacBook, затем вы сможете использовать этот passkey с распознаванием лица, отпечатком пальца, PIN-кодом или паролем устройства на нескольких устройствах, связанных с этой учетной записью iCloud.",
            "title": "О Passkeys"
          },
          "add": {
            "button": "Добавить новый Passkey",
            "error": "Произошла ошибка при добавлении нового passkey.",
            "success": "Новый passkey добавлен."
          },
          "delete": {
            "button": "Удалить Passkey",
            "error": "Произошла ошибка при удалении этого passkey.",
            "success": "Passkey удален."
          },
          "edit": {
            "error": "Произошла ошибка при сохранении имени passkey.",
            "name": "Имя Passkey",
            "success": "Имя passkey обновлено.",
            "title": "Дайте вашему Passkey имя, чтобы отличать его от других"
          },
          "info": "Passkey — это простая и безопасная альтернатива паролям, подтверждающая вашу личность с помощью касания, распознавания лица, пароля устройства или PIN-кода.",
          "none": "Нет настроенных Passkey.",
          "reallyDelete": "Вы уверены, что хотите удалить Passkey?",
          "registeredPasskeys": "Ваши зарегистрированные Passkey:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "Вы уверены, что хотите удалить устройство аутентификации?",
        "secMFA": "Двухфакторная аутентификация",
        "secPwdChange": "Сменить пароль",
        "title": "Безопасность"
      },
      "setPW": {
        "acceptTC": "Пожалуйста, подтвердите наши {terms} и прочитайте нашу {privacy}.",
        "killSSO": "Аннулировать все активные сеансы",
        "msg": {
          "tokenExpired": "Срок действия ссылки или кода для пароля истек. Пожалуйста, перейдите по ссылке, чтобы сбросить пароль: {link}."
        },
        "privacy": "Политика защиты данных",
        "terms": "Условия и положения",
        "title": "Введите новый пароль"
      }
    },
    "validations": {
      "hasDigit": "Должна содержать цифру(ы)",
      "hasLowercase": "Должна содержать строчные буквы",
      "hasSpecial": "Должна содержать специальные символы: {chars}",
      "hasUppercase": "Должна содержать заглавные буквы",
      "invalidCharacters": "Содержит недопустимые символы",
      "maxLength": "Разрешено максимум {max} символов",
      "minLength": "Требуется минимум {min} символов",
      "notSameAsEmail": "Слишком похож на адрес электронной почты",
      "onlyValidCharactersAllowed": "Разрешены только буквы, цифры и пробелы.",
      "required": "Обязательное поле",
      "sameAsPassword": "Пароли не совпадают",
      "tcAccepted": "Пожалуйста, подтвердите наши условия и положения.",
      "validEmail": "Недействительный адрес электронной почты.",
      "validOTP": "Пожалуйста, введите код подтверждения."
    }
  }
}
